"use client";

import { useRouter, usePathname } from "next/navigation";
import { IoClose } from "react-icons/io5";

import { getLocalePrefix } from "@/utils/getLocaleFromPath";

interface SearchCloseButtonProps {
  className?: string;
  onClose?: () => void;
}

export default function SearchCloseButton({ className = "", onClose }: SearchCloseButtonProps) {
  const router = useRouter();
  const pathname = usePathname();
  const localePrefix = getLocalePrefix(pathname);

  const handleClose = () => {
    if (onClose) {
      onClose();
      return;
    }

    if (typeof window !== "undefined" && window.history.length > 1) {
      router.back();
    } else {
      router.push(localePrefix || "/");
    }
  };

  return (
    <button
      type="button"
      onClick={handleClose}
      className={
        "flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-gray-100 text-2xl text-gray-800 shadow-sm transition-colors hover:bg-gray-200 dark:bg-gray-800 dark:text-white dark:hover:bg-gray-700 " +
        className
      }
      aria-label="Close search"
    >
      <IoClose />
    </button>
  );
}
